import { User, UserSchema } from '../schemas/User.schema';
import UserRole from '../types/UserRole.enum';
import Paths from './Paths';
import { useEffect, useState } from 'react';
import { redirect } from 'react-router-dom';

export enum StorageAuthKeys {
  accessToken = 'at',
  USERNAME = 'username',
  USER_ROLE = 'role',
  USER_ID = 'userId',
  USER_EMAIL = 'email',
}
export const saveAuthData = (user: User) => {
  if (user.accessToken) {
    localStorage.setItem(StorageAuthKeys.accessToken, user.accessToken);
  }
  if (user.user?.name) {
    localStorage.setItem(StorageAuthKeys.USERNAME, user.user.name);
  }
  if (user.user?.role) {
    localStorage.setItem(StorageAuthKeys.USER_ROLE, user.user.role);
  }
  if (user.user?.id) {
    localStorage.setItem(StorageAuthKeys.USER_ID, user.user.id);
  }
  if (user.user?.email) {
    localStorage.setItem(StorageAuthKeys.USER_EMAIL, user.user.email);
  }
};

export const getAuthData = (): User | null => {
  const accessToken = localStorage.getItem(StorageAuthKeys.accessToken);
  const username = localStorage.getItem(StorageAuthKeys.USERNAME);
  const role = localStorage.getItem(StorageAuthKeys.USER_ROLE);
  const userId = localStorage.getItem(StorageAuthKeys.USER_ID);
  const email = localStorage.getItem(StorageAuthKeys.USER_EMAIL);
  const storedUser: User = {
    accessToken,
    user: {
      id: userId,
      name: username,
      email,
      role,
    },
  };
  const parsedAuth = UserSchema.safeParse(storedUser);
  if (parsedAuth.success) return parsedAuth.data;
  return null;
};

export const clearAuthData = () => {
  Object.values(StorageAuthKeys).forEach((key) => {
    localStorage.removeItem(key);
  });
};

export function useAuth() {
  const [auth, setAuth] = useState<User | null>(null);

  useEffect(() => {
    const parsedAuth = UserSchema.safeParse(getAuthData());
    if (parsedAuth.success) {
      setAuth(parsedAuth.data);
    } else {
      redirect(Paths.SIGN_IN);
    }
  }, []);

  return auth;
}

export function useUserRole() {
  const user = useAuth();

  return {
    isClient: user?.user.role === UserRole.CLIENT,
    isOwnerOrSuperAdmin:
      user?.user.role && [UserRole.ADMIN].includes(user.user.role as UserRole),
  };
}
